import React from 'react';
import { Box, IconButton, ListItem, Typography } from '@mui/material';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';

const normalizeExternalUrl = (rawUrl) => {
  const s = (rawUrl ?? '').toString().trim();
  if (!s) return '';
  if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(s)) return s;
  if (s.startsWith('//')) return `${window.location.protocol}${s}`;
  return `https://${s}`;
};

const LinkGroupItem = ({ item }) => {
  const { label, url, rank } = item || {};
  const href = normalizeExternalUrl(url);

  const rankStyles = {
    1: { bgcolor: '#FFD740', color: '#FFFFFF' },
    2: { bgcolor: '#E0E0E0', color: '#FFFFFF' },
    3: { bgcolor: '#FFAB91', color: '#FFFFFF' },
  };

  const badgeStyle = rankStyles[rank] || { bgcolor: '#EEEEEE', color: '#999' };

  return (
    <ListItem disableGutters sx={{ px: 0, py: 0 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', width: '100%' }}>
        <Box
          sx={{
            width: 22,
            height: 22,
            borderRadius: '50%',
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 14,
            fontWeight: 800,
            mr: 1.2,
            ...badgeStyle,
            color: '#fff', 
          }}
        >
          {rank || ''}
        </Box>

        <Typography
          variant="body2"
          noWrap
          sx={{
            fontSize: 15,
            fontWeight: 500,
            color: '#222',
            flex: 1,
            minWidth: 0,
            letterSpacing: '-0.3px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {label || '-'}
        </Typography>

        <IconButton
          aria-label="링크 열기"
          size="small"
          disabled={!href}
          onClick={(e) => {
            e.stopPropagation();
            if (!href) return;
            window.open(href, '_blank', 'noopener,noreferrer');
          }}
          sx={{ ml: 1, p: 0.25, flexShrink: 0, cursor: href ? 'pointer' : 'default', '&.Mui-disabled': { opacity: 0.35 } }}
        >
          <ArrowOutwardIcon sx={{ fontSize: 20, color: '#333', stroke: '#333', strokeWidth: 1.5 }} />
        </IconButton>
      </Box>
    </ListItem>
  );
};

export default LinkGroupItem;


